"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _FlagForm = _interopRequireDefault(require("./FlagForm"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross4"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _reactRedux = require("react-redux");
var _conditionToString = _interopRequireDefault(require("./conditionToString.js"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable no-nested-ternary */
var Boilerplate = window.cccisd.boilerplate;
var Flags = function Flags(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    list = _useState2[0],
    setList = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var currentProjectId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentProjectId;
  });
  var getFlagList = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var response, data;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setLoading(true);
            _context.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('api.assignment.flag.index') + "?projectId=".concat(currentProjectId));
          case 1:
            response = _context.v;
            setLoading(false);
            data = response.data.data.map(function (item) {
              return {
                id: item.id,
                name: item.name,
                description: item.description,
                definition: item.definition,
                subscriberType: item.subscriber_type,
                createdAt: item.created_at,
                schedule: item.schedule,
                emails: item.subscriber_type === 'email' ? item.subscriber_list : [],
                phones: item.subscriber_type === 'sms' ? item.subscriber_list : []
              };
            });
            setList(data);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getFlagList() {
      return _ref.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    getFlagList();
  }, []);
  if (!list) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      loading: true
    });
  }
  var addFlag = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
      var _response$data;
      var data, response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            data = _objectSpread(_objectSpread({
              group_id: currentProjectId
            }, (0, _pick2["default"])(values, ['name', 'description', 'definition', 'schedule', 'subscriberType'])), {}, {
              subscriberList: values.subscriberType === 'none' ? [] : values.subscriberType === 'email' ? values.emails : values.phones
            });
            _context2.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.flag.create'), data);
          case 1:
            response = _context2.v;
            if (!((_response$data = response.data) !== null && _response$data !== void 0 && _response$data.errors)) {
              _context2.n = 2;
              break;
            }
            return _context2.a(2, Promise.reject(response.data.errors));
          case 2:
            _context2.n = 3;
            return getFlagList();
          case 3:
            (0, _cccisdNotification["default"])('Flag has been added');
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function addFlag(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var updateFlag = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(values) {
      var _response$data2;
      var data, response;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            data = _objectSpread(_objectSpread({
              group_id: currentProjectId
            }, (0, _pick2["default"])(values, ['name', 'description', 'definition', 'schedule', 'subscriberType'])), {}, {
              subscriberList: values.subscriberType === 'none' ? [] : values.subscriberType === 'email' ? values.emails : values.phones
            });
            _context3.n = 1;
            return _cccisdAxios["default"].put(Boilerplate.route('api.assignment.flag.update', {
              flag: values.id
            }), data);
          case 1:
            response = _context3.v;
            if (!((_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.errors)) {
              _context3.n = 2;
              break;
            }
            return _context3.a(2, Promise.reject(response.data.errors));
          case 2:
            _context3.n = 3;
            return getFlagList();
          case 3:
            (0, _cccisdNotification["default"])('Flag has been updated');
          case 4:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function updateFlag(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var deleteFlag = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(id) {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            setLoading(true);
            _context4.n = 1;
            return _cccisdAxios["default"]["delete"](Boilerplate.route('api.assignment.flag.delete', {
              flag: id
            }));
          case 1:
            _context4.n = 2;
            return getFlagList();
          case 2:
            setLoading(false);
            (0, _cccisdNotification["default"])('Flag has been deleted');
          case 3:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function deleteFlag(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
  var columns = [{
    name: 'actions',
    label: '',
    "class": 'text-center text-nowrap',
    setStyle: function setStyle() {
      return {
        width: 0
      };
    },
    render: function render(value, row) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].buttons
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        title: "Edit flag",
        trigger: /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-success btn-xs",
          type: "button"
        }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null))
      }, /*#__PURE__*/_react["default"].createElement(_FlagForm["default"], {
        initialValues: row,
        onSubmit: updateFlag
      })), ' ', /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-danger btn-xs",
        type: "button",
        onClick: function onClick() {
          return deleteFlag(row.id);
        }
      }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)));
    }
  }, {
    name: 'name',
    label: 'Flag',
    render: function render(value, row) {
      if (!row.description) {
        return row.name;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          marginRight: '0.3em'
        }
      }, row.name), /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: row.description
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-primary"
      }, /*#__PURE__*/_react["default"].createElement(_info["default"], null))));
    }
  }, {
    name: 'definition',
    label: 'Conditions',
    render: function render(value, row) {
      return (0, _conditionToString["default"])(value);
    }
  }, {
    name: 'subscriberType',
    label: 'Actions',
    render: function render(value, row) {
      if (value === 'email') {
        return "Email to ".concat(row.emails.length, " recipient").concat(row.emails.length > 1 ? 's' : '');
      }
      if (value === 'sms') {
        return "SMS to ".concat(row.phones.length, " recipient").concat(row.phones.length > 1 ? 's' : '');
      }
      return '-';
    }
  }, {
    name: 'createdAt',
    label: 'Date Created',
    render: function render(value, row) {
      return value ? (0, _format["default"])(new Date(value), 'MM/dd/yyyy h:mm a') : '-';
    }
  }];
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
    loading: loading
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].buttonArea
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Add flag",
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary"
    }, "Add Flag")
  }, /*#__PURE__*/_react["default"].createElement(_FlagForm["default"], {
    onSubmit: addFlag
  }))), /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
    columns: columns,
    data: list,
    showPerPageOptions: false
  }));
};
Flags.propTypes = {};
Flags.defaultProps = {};
var _default = exports["default"] = Flags;